// extracted by mini-css-extract-plugin
export var ProjectEntry = "ProjectEntry-module--ProjectEntry--b0ggH";
export var ModalThumb = "ProjectEntry-module--ModalThumb--iP3qX";
export var ModalThumbPlaceholder = "ProjectEntry-module--ModalThumbPlaceholder--n+tna";
export var ProjectEntryContainer = "ProjectEntry-module--ProjectEntryContainer--COpym";
export var ProjectEntryDetailsContainer = "ProjectEntry-module--ProjectEntryDetailsContainer--6jEnw";